import axios from 'axios';
import { createReportSchedulerBody, updateReportSchedulerBody } from '@carboncare/schemas';
import { preflight } from './schemaPreflight';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export interface ReportScheduler {
    id: string;
    name: string;
    frequency: 'daily' | 'weekly' | 'monthly';
    report_type: 'analytics' | 'emission_dashboard';
    type: 'MTD' | 'L12M' | 'YTD';
    subtype: string;
    licensee_id: number;
    target_user_types: number[] | null;
    active: boolean;
    last_run_at: string | null;
    next_run_at: string | null;
    created_at: string;
}

export interface CreateReportSchedulerData {
    name: string;
    frequency: 'daily' | 'weekly' | 'monthly';
    report_type: 'analytics' | 'emission_dashboard';
    type: 'MTD' | 'L12M' | 'YTD';
    subtype: string;
    licensee_id: number;
    target_user_types: number[] | null;
}

const reportSchedulerApi = {
    getAll: async (params?: { page?: number; limit?: number; sortBy?: string; sortOrder?: 'asc' | 'desc' }): Promise<{ data: ReportScheduler[]; total: number; page: number; limit: number }> => {
        const token = localStorage.getItem('authToken');
        const response = await axios.get(`${API_BASE_URL}/report-schedulers`, {
            headers: { Authorization: `Bearer ${token}` },
            params,
        });
        return {
            data: response.data.data,
            total: response.data.total ?? response.data.data.length,
            page: response.data.page ?? params?.page ?? 1,
            limit: response.data.limit ?? params?.limit ?? 10,
        };
    },

    create: async (data: CreateReportSchedulerData): Promise<ReportScheduler> => {
        const token = localStorage.getItem('authToken');
        preflight(createReportSchedulerBody, data);
        const response = await axios.post(`${API_BASE_URL}/report-schedulers`, data, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data.data;
    },

    update: async (id: string, data: Partial<CreateReportSchedulerData | { active: boolean }>): Promise<ReportScheduler> => {
        const token = localStorage.getItem('authToken');
        preflight(updateReportSchedulerBody, data);
        const response = await axios.patch(`${API_BASE_URL}/report-schedulers/${id}`, data, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data.data;
    },

    delete: async (id: string): Promise<void> => {
        const token = localStorage.getItem('authToken');
        await axios.delete(`${API_BASE_URL}/report-schedulers/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
    }
};

export default reportSchedulerApi;
